// extracted by mini-css-extract-plugin
export var activeFilterButton = "_kb-c";
export var backButton = "_kb-4";
export var backIcon = "_kb-5";
export var chevronShortcut = "_kb-6";
export var container = "_kb-1";
export var editor = "_kb-8";
export var editorWrapper = "_kb-7";
export var prefix = "_kb-2";
export var searchIcon = "_kb-3";
export var suffix = "_kb-9";
export var suffixContent = "_kb-a";
export var suffixText = "_kb-b";
export var wrapper = "_kb-0";